var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.6233 8.23042L9.27141 5.97106L5.6233 3.7117V8.23042ZM13.749 2.33349C13.8403 2.68746 13.9036 3.16192 13.9458 3.76442C13.995 4.36691 14.0161 4.88657 14.0161 5.33844L14.0582 5.97106C14.0582 7.62039 13.9458 8.83291 13.749 9.60863C13.5732 10.2864 13.1655 10.7232 12.5329 10.9115C12.2026 11.0094 11.598 11.0772 10.6702 11.1224C9.75642 11.1751 8.91995 11.1977 8.14675 11.1977L7.02912 11.2429C4.08392 11.2429 2.24932 11.1224 1.52532 10.9115C0.892698 10.7232 0.485009 10.2864 0.309281 9.60863C0.217903 9.25466 0.154641 8.7802 0.112466 8.1777C0.0632621 7.5752 0.0421747 7.05555 0.0421747 6.60368L0 5.97106C0 4.32173 0.112466 3.1092 0.309281 2.33349C0.485009 1.65568 0.892698 1.21887 1.52532 1.03059C1.85569 0.932686 2.46019 0.864905 3.38804 0.819718C4.30182 0.766999 5.13829 0.744406 5.91149 0.744406L7.02912 0.699219C9.97432 0.699219 11.8089 0.819718 12.5329 1.03059C13.1655 1.21887 13.5732 1.65568 13.749 2.33349Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYutube);
export default __webpack_public_path__ + "static/media/yutube.8f3e739c87e0cbd5648f1964089142ec.svg";
export { ForwardRef as ReactComponent };